import clsx from "clsx"
import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { resolveItemImage } from "@/helpers/itemImage"
import { rarityStyle } from "@/helpers/rarity"
import { isBroken } from "@/modals/constructor/inventory/InventoryModal/helpers"
import styles from "./ItemCard.module.scss"
import { IItemCardProps } from "./types"

const ItemCardComponent: FC<IItemCardProps> = ({ item, onClick }) => {
  const { t } = useTranslation("inventory")
  const image = resolveItemImage(item.definitionCode)
  return (
    <button
      type="button"
      className={clsx(styles.ItemCard, { [styles.broken]: isBroken(item) })}
      onClick={() => onClick(item)}
      style={rarityStyle(item)}
    >
      {image ? (
        <img
          className={styles.ItemCard_icon}
          src={image}
          alt=""
          loading="lazy"
        />
      ) : (
        <span className={styles.ItemCard_icon} />
      )}
      <span className={styles.ItemCard_name}>
        {t(`item.${item.definitionCode}.name`)}
      </span>
      {item.quantity > 1 && (
        <span className={styles.ItemCard_qty}>×{item.quantity}</span>
      )}
    </button>
  )
}

export const ItemCard = memo(ItemCardComponent)
